export const FETCH_LOGS_PENDING = 'FETCH_LOGS_PENDING';
export const FETCH_LOGS_SUCCESS = 'FETCH_LOGS_SUCCESS';
export const FETCH_LOGS_ERROR = 'FETCH_LOGS_ERROR';
export const FILE_SYSTEM_HEALTH = 'FILE_SYSTEM_HEALTH';
